import { EntityModule } from '../entity.module';

import { ExamResult } from '@/interfaces/examResult';
import { ExamResultFilters } from '@/interfaces/filters/examResultFilters';
import { ListResponse } from '@/interfaces/list';
import { ExamResultResource, examResultResource } from '@/resources/examResult.resource';
import store from '@/store/store';

/**
 * Moduł wyników egzaminu
 *
 * @export
 * @class ExamResultModule
 * @extends {EntityModule<ExamResult, ExamResultResource>}
 */
export class ExamResultModule extends EntityModule<ExamResult, ExamResultResource> {
  constructor() {
    super(examResultResource);

    this.mutations = {
      ...this.mutations,
      /**
       * Dodaje do listy
       *
       * @param {*} localState
       * @param {Exam} entity
       */
      add(localState: any, entity: ExamResult): void {
        assignEntities(entity);
        localState.list.unshift(entity);
      },

      /**
       * Aktualizuje liste
       *
       * @param {*} localState
       * @param {Exam} entity
       */
      update(localState: any, entity: ExamResult): void {
        assignEntities(entity);
        const index = localState.list.findIndex((item: ExamResult) => item.id === entity.id);
        localState.list.splice(index, 1, entity);
      }
    };

    this.actions = {
      ...this.actions,
      /**
       * Pobiera liste wyników egzaminu
       *
       * @param {*} context
       * @param {ExamResultFilters} filters
       * @returns {Promise<void>}
       */
      list: (context: any, filters: ExamResultFilters): Promise<void> => {
        if (context.state.filters) {
          filters = { ...context.state.filters, ...filters };
        }
        return this.resource.examResultList(filters).then(({ list, count }: ListResponse<ExamResult>) => {
          context.commit('saveList', list);
          context.commit('saveCount', count);
        });
      }
    };
  }
}

/**
 * Przypisuje powiązane encje
 *
 * @param {ExamResult} entity
 */
function assignEntities(entity: ExamResult) {
  entity.profile = store.getters['team/player/entity']
    ? store.getters['team/player/entity']
    : store.getters['team/player/byId'](entity.profileId);

  entity.exam = store.getters['exam/entity'] ? store.getters['exam/entity'] : store.getters['exam/byId'](entity.examId);
}

export default new ExamResultModule();
